// Texty produktové karty (productCard.js).
import { plural } from '../plural.js';

export default {
  bestseller: 'Bestseller',
  /** nativní text dostupnosti karty, kterým modul čte, jestli je skladem (čte se, nekreslí) */
  inStock: 'Skladem',
  /** 1 recenze / 2–4 recenze / 5+ recenzí */
  reviewsWord: (n) => plural(n, ['recenze', 'recenze', 'recenzí']),
  /** „N ks za M Kč" → CTA „Do košíku za 1 290 Kč" */
  ctaSuffix: (price) => ' za ' + price,
};
